var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgBackIconBold = function SvgBackIconBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.471,
    height: 18.987
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2,
    "data-name": "Group 182"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.471 9.412H2.328",
    "data-name": "Path 83"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M9.08 1.414L1 9.494l8.08 8.08",
    "data-name": "Path 84"
  }))));
};
export default SvgBackIconBold;